import { Component, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'
import { mapState } from 'vuex';
import { ISession, IUserService, IUsersServices } from '../../types';

@Component({
  components: {
		Multiselect
  },
  computed: mapState({
    Authenticated: (state: {session: ISession}) => state.session.UserId ? true : false,
    Moderator: (state: {session: ISession}) => state.session.roles != undefined ? true : false,
    CurrentService: (state: {session: ISession}) => state.session.service,
  })
})

export default class NavBar extends Vue {

	private namespace: string = '/Account';

  private Authenticated!: boolean;

  private Moderator!: boolean;

  private CurrentService!: string;

  private services: IUsersServices[] | null = null;

  private loading: boolean = false;

	private error: boolean = false;
	
	private set SingleService (service: IUserService) {

		if (service != undefined) {

			this.$store.commit('saveUserId', service.userId);
			
			if (this.$route.path.includes('/Console')) {
				
				this.$router.push({name: 'overview'});
			}
		}
	}

	private get SingleService (): IUserService {

		const noService = {label: this.$tc('shared.notSet') as string, userId: ''};

		if (this.services != null) {

			const service = this.services.find(service => 
				service.userId === this.CurrentService
			);

			return service 
				? {label: service.displayName, userId: service.userId} 
				: noService;
		}

		return noService;
	}

	private get Services (): IUserService[] | null {

		if (this.services != null) {
			
			return this.services.map(service => (

				{label: service.displayName, userId: service.userId}
			));
		}

		return null;
	}

  beforeMount () {

    if (this.Moderator) {

      return this.getServices();
    }
  }

  private async getServices () {

    this.loading = true;

		try {

			const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/AllUsersServices`);

			this.loading = false;
			this.$store.commit('saveServices', response.data);
			return this.services = response.data;

		} catch (err) {

			this.loading = false;
			this.error = !this.error;
		}
	}

  private async impersonate () {

    try {

			const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/Impersonate`, {
				params: {
					userId: this.SingleService.userId
				}
			});

			this.$store.commit('createSession', response.data);

			if (this.$route.path.includes('/Console')) {

				this.$router.replace({name: 'overview'});
			}
		} catch (err) {

			console.error(err);
		}
  }

	@Watch('Moderator')
  updateServices (nextVal: boolean, prevVal: boolean) {
    
    if (nextVal && this.services === null) {

      return this.getServices();
    }
  }
}